:host {
    width: 100%;
    display: none;
}

:host(.is-active) {
    display: block;

    // fixes issues of contents with float
    &::after {
        content: "";
        display: table;
        clear: both;
    }
}

slot {
    box-sizing: border-box;
}
